import React, { useEffect, useState } from "react";
import NewsItem from "../components/NewsItem"; // Component to render individual news articles
// import AdBanner from "../components/AdBanners"; // Component to render ad banners

const backendUrl = process.env.REACT_APP_BACKEND_URL; // Backend API URL from environment variables

const Technology = ({ searchQuery }) => {
  // State for storing all fetched technology news
  const [news, setNews] = useState([]);
  // State for storing news filtered by search query
  const [filteredNews, setFilteredNews] = useState([]);
  // Loading state to show spinner while fetching data
  const [loading, setLoading] = useState(true);
  // Tracks if this is the initial load to handle spinner rendering
  const [initialLoad, setInitialLoad] = useState(true);
  // Pagination: current page number
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5; // Number of posts displayed per page

  /**
   * Fetch technology news from backend API and manage caching with localStorage
   * This allows users to see cached content immediately while fresh content loads
   */
  useEffect(() => {
    const cachedNews = localStorage.getItem("cachedTechnologyNews");
    let parsedCache = [];

    // If cached news exists, parse it and display immediately
    if (cachedNews) {
      parsedCache = JSON.parse(cachedNews);
      setNews(parsedCache);
      setFilteredNews(parsedCache);
      setLoading(false);
      setInitialLoad(false);
    }

    // Fetch latest technology news from backend
    fetch(`${backendUrl}/api/news/technology`)
      .then((res) => res.json())
      .then((fetchedData) => {
        // Compare fetched data with cached data to avoid unnecessary updates
        const cachedString = JSON.stringify(parsedCache);
        const fetchedString = JSON.stringify(fetchedData);

        if (cachedString !== fetchedString) {
          setNews(fetchedData);
          setFilteredNews(fetchedData);
          localStorage.setItem("cachedTechnologyNews", fetchedString); // Update local cache
        }
      })
      .catch((err) => {
        console.error("Error fetching technology news:", err);
      })
      .finally(() => {
        setLoading(false);
        setInitialLoad(false);
      });
  }, []);

  /**
   * Filter technology news based on searchQuery
   * Updates automatically whenever `searchQuery` or `news` changes
   */
  useEffect(() => {
    if (!searchQuery) {
      setFilteredNews(news);
    } else {
      const filtered = news.filter((article) =>
        article.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredNews(filtered);
    }
  }, [searchQuery, news]);

  // Pagination logic
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = filteredNews.slice(firstPostIndex, lastPostIndex);
  const totalPages = Math.ceil(filteredNews.length / postsPerPage);

  /**
   * Update live date & time widget every second
   * Uses IDs "widget-date" and "widget-time" to display current date/time
   */
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const dateOptions = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
      const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };

      const dateEl = document.getElementById("widget-date");
      const timeEl = document.getElementById("widget-time");

      if (dateEl && timeEl) {
        dateEl.textContent = now.toLocaleDateString("en-US", dateOptions);
        timeEl.textContent = now.toLocaleTimeString("en-US", timeOptions);
      }
    }, 1000);
    return () => clearInterval(interval); // Cleanup interval when component unmounts
  }, []);

  return (
    <div className="container mx-auto px-4 mt-6 lg:flex gap-6">
      {/* Left Column - Technology Feed */}
      <div className="lg:w-8/12 w-full mb-5 mt-5">
        {initialLoad && loading ? (
          // Loading spinner during initial fetch
          <div className="flex justify-center items-center mt-10">
            <div className="flex justify-center items-center w-screen bg-gray-50">
              <div className="w-5 h-5 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          </div>
        ) : (
          <>
            {currentPosts.length > 0 ? (
              currentPosts.map((article, index) => (
                <React.Fragment key={index}>
                  <NewsItem article={article} />
                  {/* Optional inline ad after every 2 articles */}
                  {(index + 1) % 2 === 0 && (
                    <div className="my-6 text-center">
                      {/* Replace with Propeller ad or script if needed */}
                      {/* <img
                        src="https://placehold.co/728x90?text=Tech+Ad"
                        alt="Ad"
                        className="mx-auto border"
                      /> */}
                    </div>
                  )}
                </React.Fragment>
              ))
            ) : (
              // Message when no articles match the search query or no news available
              <p className="text-center text-red-500">
                {searchQuery ? "No results found." : "No technology news available."}
              </p>
            )}

            {/* Pagination buttons */}
            <div className="flex justify-center mt-6 space-x-2">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                <button
                  key={num}
                  onClick={() => setCurrentPage(num)}
                  className={`px-3 py-1 border rounded ${num === currentPage ? "bg-black text-white" : "bg-gray-200 hover:bg-gray-300"}`}
                >
                  {num}
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Right Column - Sidebar */}
      <aside className="lg:w-4/12 w-full mt-6 lg:mt-0">
        {/* Sidebar Ad Banner 300x250 */}
        {/* <AdBanner keyId="e34bc345ee5e3a91f6b935de958d5097" width={300} height={250} delay={3000} /> */}

        {/* Live Date & Time Widget */}
        <div className="aside-widget p-4 mb-6">
          <div className="widget-header font-bold">Current Time</div>
          <div id="widget-date" className="date"></div>
          <div id="widget-time" className="time"></div>
        </div>

        {/* Sidebar Ad Banner 160x300 */}
        {/* <AdBanner keyId="cbc005c25e986689ab2690be13244d" width={160} height={300} delay={6000} style={{ marginBottom: "5px" }} mobileHide /> */}

           {/* Newsletter */}
        {/* <div className="bg-gray-100 p-4 mb-6">
          <h3 className="text-md font-semibold mb-2">Enter your email address:</h3>
          <input
            type="email"
            placeholder="Your email"
            className="w-full p-2 border rounded mb-2"
          />
          <button className="bg-gray-600 text-white px-4 py-2 w-full rounded hover:bg-gray-700">
            Subscribe
          </button>
          <p className="text-xs mt-2">Delivered by Newstarn</p>
        </div> */}

        {/* Trending Posts */}
        {/* <div className="bg-gray-100 p-4 mb-6">
          <h3 className="text-md font-semibold mb-3">Trending</h3>
          <ul className="list-disc pl-4 text-sm space-y-2">
            {news.slice(0, 6).map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}
          </ul>
        </div> */}

        {/* Fixed Ad Slot */}
        {/* <div className="hidden lg:block sticky top-4">
          <img
            src="https://placehold.co/800x450?text=Sidebar+Tech+Ad"
            alt="Ad Space"
            className="w-full h-auto border"
          />
        </div> */}
      </aside>
    </div>
  );
};

export default Technology;
